var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{class:['aside', _vm.bgImg ? 'aside' : 'aside-asset-bg']},[_vm._m(0),_c('img',{attrs:{"src":_vm.bgImg,"alt":""}})]),_c('div',{staticClass:"rightback"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftback"},[_c('div',{staticClass:"toplogo"},[_c('i',{staticClass:"iconfont-ot-website icon-brand"},[_vm._v("")])])])
}]

export { render, staticRenderFns }